var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-container signoff" },
    [
      _vm.showModal
        ? _c(
            "modal-box",
            {
              attrs: { open: _vm.showModal, width: "1080px" },
              domProps: {
                onClose: _vm.closeModal,
                enableHeader: true,
                enableFooter: true,
                enableHeaderClose: true,
                transparentOverlay: false,
                closeOnClickOutside: true,
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("div", { staticClass: "flex-row flex-1" }, [
                    _c("div", { staticClass: "flex-col" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.asset.name))]),
                    ]),
                    _c("span", { staticClass: "separator ml-6 mr-4 mt-1" }),
                    _c("div", { staticClass: "flex-col" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.$t("updateDate")))]),
                    ]),
                  ]),
                ]
              ),
              _c("span", [
                _c("div", { staticClass: "flex-col edit-ribbon" }, [
                  _c("div", { staticClass: "mt-3 ribbon" }, [
                    _c(
                      "label",
                      {
                        staticClass: "ribbon-label",
                        attrs: { for: "ribbonValue" },
                      },
                      [_vm._v(_vm._s(_vm.$t("value")) + "*")]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dateRibbonText,
                          expression: "dateRibbonText",
                        },
                      ],
                      staticClass: "ribbon-input",
                      attrs: {
                        id: "ribbonValue",
                        placeholder: _vm.$t("value"),
                      },
                      domProps: { value: _vm.dateRibbonText },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.dateRibbonText = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "mt-3 ribbon" }, [
                    _c(
                      "label",
                      {
                        staticClass: "ribbon-label",
                        attrs: { for: "ribbonVersion" },
                      },
                      [_vm._v(_vm._s(_vm.$t("version")) + "*")]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dateRibbonValue,
                          expression: "dateRibbonValue",
                        },
                      ],
                      staticClass: "ribbon-input",
                      attrs: {
                        id: "ribbonVersion",
                        placeholder: _vm.$t("version"),
                      },
                      domProps: { value: _vm.dateRibbonValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.dateRibbonValue = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { class: _vm.errorExists ? "error-text" : "" }, [
                    _vm.errorExists && _vm.valueIsEmpty
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$t("thisFieldIsMandatory"))),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "mt-3 ribbon" }, [
                    _c(
                      "label",
                      {
                        staticClass: "ribbon-label",
                        attrs: { for: "ribbonReason" },
                      },
                      [_vm._v(_vm._s(_vm.$t("reason")) + "*")]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.updComment,
                          expression: "updComment",
                        },
                      ],
                      staticClass: "ribbon-input",
                      attrs: {
                        id: "ribbonReason",
                        placeholder: _vm.$t("reason"),
                      },
                      domProps: { value: _vm.updComment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.updComment = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { class: _vm.errorExists ? "error-text" : "" }, [
                    _vm.errorExists && _vm.commentIsEmpty
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$t("thisFieldIsMandatory"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("br"),
              ]),
              _c(
                "span",
                {
                  staticClass: "footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("div", { staticClass: "flex-row reverse" }, [
                    _c("div", { staticClass: "flex-col flex-align-end" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn mt-1",
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "flex-row flex-1" }, [
        _c("div", { staticClass: "flex-col flex-1 rotate" }, [
          _c(
            "div",
            { staticClass: "flex-row rotate-content redFont textnowrap" },
            [_vm._v(_vm._s(_vm.datesGeneralStrategyobj.dateRibbonText))]
          ),
        ]),
        _c("div", { staticClass: "flex-col flex-1 rotate" }, [
          _c(
            "div",
            { staticClass: "flex-row rotate-content redFont textnowrap" },
            [
              _vm._v(
                " " + _vm._s(_vm.datesGeneralStrategyobj.dateRibbonValue) + " "
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }